import AppComponent from '../../mixins/app-component'

import AppButton from '../app-button'
import AppCountdown from '../app-countdown'
import AppIcon from '../app-icon'
import AppSocialsLinks from '../app-socials-links'

export default
{
    name: 'app-home-slide-0',

    mixins: [
        AppComponent
    ],

    components: {
        AppButton,
        AppCountdown,
        AppIcon,
        AppSocialsLinks
    },

    props: {
        activeIndex: { type: Number, default: 0 },
        activeLevel: { type: Number, default: 0 }
    },

    methods: {
        onNextSlide() {
            this.eventHub.$emit('page-home:onNextSlide')
        },

        _showPopin() {
            this.eventHub.$emit('app-popin-email:show-popin')
        },

        _clickOnBeNotified() {
            this.eventHub.$emit('app-popin-email:show-popin')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-home-slide-0/script.js